import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IDataUrlParam } from 'src/app/shared/framework/images/models/DataUrlParam';

import { EmployeeService } from 'src/app/shared/personnel-files/services/employee.service';

@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
})
export class ProfilePictureComponent implements OnChanges, OnInit {
  /**CHR 1, LHR 2, Employee 3, Manager 3, Delegate 3, Matrix 3, Candidate 4 */
  @Input() whoKind: number;
  @Input() whoId: number;

  @Input() width?: number;
  @Input() text = '';
  @Input() backgroundWhite = false;

  public photo$: Observable<IDataUrlParam>;

  private loadedPictureKey?: string;

  constructor(private _employeeService: EmployeeService) { }

  ngOnChanges() {
    this.getImage();
  }

  ngOnInit() {
    this.getImage();
  }

  public getImage() {
    const whoKind = this.whoKind || 3;
    const pictureKey = `${whoKind}:${this.whoId || 0}`;

    if (pictureKey === this.loadedPictureKey) {
      return;
    }

    this.loadedPictureKey = pictureKey;
    this.photo$ = whoKind === 3 || whoKind === 1 || whoKind === 2 || whoKind === 4 || whoKind === 6
      ? this._employeeService.getEmployeePicture(this.whoId, whoKind, true)
      : of(null);
  }
}
